import { render, staticRenderFns } from "./AssociateWineCard.vue?vue&type=template&id=34a04d58&scoped=true"
import script from "./AssociateWineCard.vue?vue&type=script&lang=js"
export * from "./AssociateWineCard.vue?vue&type=script&lang=js"
import style0 from "./AssociateWineCard.vue?vue&type=style&index=0&id=34a04d58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a04d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a04d58')) {
      api.createRecord('34a04d58', component.options)
    } else {
      api.reload('34a04d58', component.options)
    }
    module.hot.accept("./AssociateWineCard.vue?vue&type=template&id=34a04d58&scoped=true", function () {
      api.rerender('34a04d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/AssociateWine/AssociateWineCard.vue"
export default component.exports